import { useLayoutEffect, useRef, useState } from 'react';
import { FractalCanvas } from './FractalCanvas';

export const FRACTAL_DPR_CHANGE_EVENT = 'fractal:dprchange';

export function ResponsiveFractalCanvas({ width: presetWidth, height: presetHeight, ...props }) {
  const wrapperRef = useRef(null);
  const [dimensions, setDimensions] = useState(null);

  useLayoutEffect(() => {
    const wrapper = wrapperRef.current;
    let mediaQuery;
    const deviceScale = () => {
      const dpr = window.devicePixelRatio;
      return Number.isFinite(dpr) && dpr > 0 ? dpr : 1;
    };
    const updateSize = () => {
      const cssWidth = wrapper.getBoundingClientRect().width || wrapper.clientWidth;
      if (cssWidth <= 0) return;
      const width = Math.min(presetWidth, Math.max(1, Math.round(cssWidth * deviceScale())));
      const height = Math.min(presetHeight, Math.max(1, Math.round(width * presetHeight / presetWidth)));
      setDimensions(previous => previous?.width === width && previous?.height === height
        ? previous : { width, height });
    };
    const onDprChange = () => {
      updateSize();
      watchDpr();
    };
    const watchDpr = () => {
      if (mediaQuery?.removeEventListener) mediaQuery.removeEventListener('change', onDprChange);
      else mediaQuery?.removeListener?.(onDprChange);
      if (typeof window.matchMedia !== 'function') return;
      mediaQuery = window.matchMedia(`(resolution: ${deviceScale()}dppx)`);
      if (mediaQuery?.addEventListener) mediaQuery.addEventListener('change', onDprChange);
      else mediaQuery?.addListener?.(onDprChange);
    };

    updateSize();
    watchDpr();
    const observer = typeof ResizeObserver === 'undefined' ? null : new ResizeObserver(updateSize);
    observer?.observe(wrapper);
    window.addEventListener('resize', updateSize);
    window.addEventListener(FRACTAL_DPR_CHANGE_EVENT, onDprChange);
    return () => {
      observer?.disconnect();
      window.removeEventListener('resize', updateSize);
      window.removeEventListener(FRACTAL_DPR_CHANGE_EVENT, onDprChange);
      if (mediaQuery?.removeEventListener) mediaQuery.removeEventListener('change', onDprChange);
      else mediaQuery?.removeListener?.(onDprChange);
    };
  }, [presetWidth, presetHeight]);

  return <div className="responsive-fractal" ref={wrapperRef}
    style={{ maxWidth: presetWidth, '--fractal-aspect': `${presetWidth} / ${presetHeight}` }}>
    {dimensions && <FractalCanvas width={dimensions.width} height={dimensions.height} {...props} />}
  </div>;
}
